import React from 'react';
import _merge from 'lodash/merge';
import Styled from './styles';

export interface ThumbContentProps extends React.ComponentPropsWithRef<'div'> {
  /** Props passed from internal Slider. */
  internalProps: {
    isTicker?: boolean;
    alwaysShowTeardrop?: boolean;
    disabled?: boolean;
    $theme?: any;
    isThumbHover?: boolean
  };
  /** Props which will be passed to wrapper element */
  wrapperProps?: React.ComponentPropsWithRef<any>;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** Content of slider thumb.
 * All other props will be forwarded to the `ThumbContent` element.
 * When it is used, it should be passed as value of `thumbContent` property in `thumbProps` prop of Slider component.
 */
const ThumbContent = (props: ThumbContentProps) => {
  const {
    wrapperProps, internalProps, theme: themeProp, ...otherProps
  } = props;

  const {
    isTicker, alwaysShowTeardrop, disabled, $theme, isThumbHover
  } = internalProps;

  const resolvedTheme = _merge({}, $theme, themeProp);
  const resolvedContentProps = {
    ...otherProps
  };
  if (!internalProps) return null;
  return (
    <Styled.ThumbContentWrapper
      isTicker={isTicker}
      alwaysShowTeardrop={alwaysShowTeardrop}
      disabled={disabled}
      isThumbHover={isThumbHover}
      {...wrapperProps}
    >
      <Styled.ThumbContent tabIndex={isTicker ? -1 : 0} disabled={disabled} $theme={resolvedTheme} {...resolvedContentProps} />
    </Styled.ThumbContentWrapper>
  );
};

ThumbContent.defaultProps = {
  wrapperProps: {},
  theme: {}
};

ThumbContent.displayName = 'ThumbContent';
export default ThumbContent;
